module.exports = __webpack_public_path__ + "static/media/star-icon.2080812c.svg";